import { forwardRef } from "react"
import { IMaskInput } from "react-imask"

// eslint-disable-next-line react/display-name
const MaskedInput = forwardRef((props, ref) => {
  const { mask, ...other } = props
  return <IMaskInput {...other} mask={mask} inputRef={ref} lazy={true} placeholderChar="_" />
})

export default MaskedInput
